import { render } from "./NoResults.vue?vue&type=template&id=938f7550&scoped=true&ts=true"
import script from "./NoResults.vue?vue&type=script&lang=ts"
export * from "./NoResults.vue?vue&type=script&lang=ts"

import "./NoResults.vue?vue&type=style&index=0&id=938f7550&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-938f7550"]])

export default __exports__